import { api } from "../api";

/**
 * updatePasswordByUserToken - Function that updates the user password by token   
 * /authenticator/change-password/token   
 * method PUT  
 * @async-function
 */
const updatePasswordByUserToken = async (token: string, password: string) => {
    const response = await api.put(
        `/authenticator/change-password/token`, {
            token,
            password
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default updatePasswordByUserToken;